(function ($) {
    'use strict';

    const storageKey = 'paytrail_checkout_billing_phone';

    /**
     * Store the latest phone value as the customer types.
     */
    function storeBillingPhone(event) {
        const field = event.target;

        if (!field.matches('#billing_phone')) {
            return;
        }

        const value = field.value.trim();

        if (value) {
            window.sessionStorage.setItem(storageKey, value);
        } else {
            window.sessionStorage.removeItem(storageKey);
        }
    }

    /**
     * Restore the phone value if Checkout has emptied the field.
     */
    function restoreBillingPhone() {
        const field = document.querySelector('#billing_phone');
        const storedValue = window.sessionStorage.getItem(storageKey);

        if (!field || !storedValue || field.value.trim()) {
            return;
        }

        field.value = storedValue;

        /*
         * Trigger WooCommerce's checkout update so the restored value is
         * also sent to the server-side session.
         */
        $(field).trigger('change');
    }

    /**
     * Remove the temporary value after reaching the order confirmation.
     */
    function clearStoredBillingPhone() {
        if (document.body.classList.contains('woocommerce-order-received')) {
            window.sessionStorage.removeItem(storageKey);
        }
    }

    document.addEventListener('input', storeBillingPhone);

    $(function () {
        clearStoredBillingPhone();
        restoreBillingPhone();
    });

    /*
     * Checkout fragments can be refreshed after the page has loaded.
     */
    $(document.body).on('updated_checkout', restoreBillingPhone);
})(jQuery);
